import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CourseGenerator } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/course-generator")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CourseGenerator />
    </RouteGuard>
  ),
});
